<!--
  <nz-row>
    <nz-col nzSpan='24'>
      <pbc-search-bar [style.width]="'100%'" (searchChange)="berichte.search$.next($event)" [search]="berichte.search$ | async"></pbc-search-bar>
    </nz-col>
  </nz-row>
  <nz-row style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between; align-items: center; align-content: space-between">
    <nz-col style="order: 1; flex-grow: 2; flex-basis: auto; ">
      <fa-kt-berichte-filter [style.width]="'100%'"></fa-kt-berichte-filter>
    </nz-col>
    <nz-col style="order: 2; flex-grow: 1; flex-basis: auto; ">
      <fa-kt-berichte-sorter [style.width]="'100%'"></fa-kt-berichte-sorter>
    </nz-col>
  </nz-row>

  <fa-kt-berichte-list [style.width]="'100%'" (select)="setBerichte($event)" [loading]="$loading | async"></fa-kt-berichte-list>


  <fa-kt-post-hochladen [style.width]="'100%'"  [value]="$postHochladen | async" (finished)="finishedPostHochladen($event)"></fa-kt-post-hochladen>
    


    <fa-kt-navigation [style.width]="'100%'" *nzSpaceItem page="marktBericht" type="dashed"></fa-kt-navigation>

-->

<nz-page-header [nzTitle]="PageTitle" [nzSubtitle]="PageSubtitle" (nzBack)="back()" nzBackIcon>
  <ng-template #PageTitle> {{ page.emoji }} {{ page.title }} </ng-template>
  <ng-template #PageSubtitle> {{ page.subtitle }} </ng-template>
  <nz-breadcrumb nz-page-header-breadcrumb>
    <pbc-breadcrumbs [pages]="page.breadcrumbs"></pbc-breadcrumbs>
  </nz-breadcrumb>
  <nz-page-header-extra>
    <!--- << page-header-buttons    -->
    <a (click)="downloadTemplate()">
      <i nz-icon nzType="file-excel" nzTheme="outline"></i>
      Vorlage
    </a>
    <!---    page-header-buttons >> -->
  </nz-page-header-extra>
  <nz-page-header-content>
    <!--- << page-header-row    -->
    <nz-row>
      <nz-col nzSpan="24">
        <fa-kt-post-hochladen [style.width]="'100%'" [value]="$postHochladen | async" (finished)="finishedPostHochladen($event)"></fa-kt-post-hochladen>
      </nz-col>
    </nz-row>
    <nz-row>
      <nz-col nzSpan="24">
        <pbc-search-bar [style.width]="'100%'" (searchChange)="berichte.search$.next($event)" [search]="berichte.search$ | async"></pbc-search-bar>
      </nz-col>
    </nz-row>
    <nz-row style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between; align-items: center; align-content: space-between">
      <nz-col style="order: 1; flex-grow: 2; flex-basis: auto">
        <fa-kt-berichte-filter [style.width]="'100%'"></fa-kt-berichte-filter>
      </nz-col>
      <nz-col style="order: 2; flex-grow: 1; flex-basis: auto">
        <fa-kt-berichte-sorter [style.width]="'100%'"></fa-kt-berichte-sorter>
      </nz-col>
    </nz-row>
    <!---    page-header-row >> -->
  </nz-page-header-content>
</nz-page-header>
<nz-content>
  <nz-row>
    <!--- << page-content    -->
    <nz-col nzSpan="24">
      <fa-kt-berichte-list [style.width]="'100%'" (select)="setBerichte($event)" [loading]="$loading | async"></fa-kt-berichte-list>
    </nz-col>
    <!---    page-content >> -->
  </nz-row>
</nz-content>
